
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 27"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.145 10.993L4.147.726C3.454.25 2.757 0 2.177 0 1.055 0 .36.9.36 2.407v22.19c0 1.505.693 2.403 1.812 2.403.58 0 1.268-.251 1.962-.727l15.004-10.267c.965-.662 1.5-1.551 1.5-2.507 0-.955-.529-1.845-1.494-2.506z"}})])
          )
        }
      }
    